import { Camera, CameraResultType, CameraSource, ImageOptions } from "@capacitor/camera";
import ons from "onsenui";
import { STRINGS } from "./strings";
import { translate } from "./translate";

export async function getDevicePhotoForProfile(): Promise<string | null> {
  return getDevicePhoto({
    quality: 90,
    correctOrientation: true, // Corrects Android orientation quirks
    width: 1024,
    height: 1024,
    allowEditing: true,
    resultType: CameraResultType.Base64,
  });
}

export async function getDevicePhotoForDocument(
  options: Partial<ImageOptions>
): Promise<string | null> {
  return getDevicePhoto({
    quality: 90,
    correctOrientation: true, // Corrects Android orientation quirks
    width: 2480,
    height: 3508,
    resultType: CameraResultType.Base64,
    ...options,
  });
}

export async function getDevicePhoto(options: ImageOptions): Promise<string | null> {
  const source = options.source ?? (await promptSourceType());

  if (source === null) {
    return null;
  }

  const photo = await Camera.getPhoto({
    ...options,
    resultType: CameraResultType.Base64,
    source: source,
  });

  if (photo.base64String === undefined) {
    return null;
  }

  return `data:image/${photo.format};base64,${photo.base64String}`;
}

async function promptSourceType(): Promise<ImageOptions["source"] | null> {
  return ons.notification
    .alert(" ", {
      animation: "none",
      modifier: "material",
      buttonLabels: <any>[translate(STRINGS.FROM_CAMERA), translate(STRINGS.FROM_GALLERY)], // TODO Remove `any` cast when "onsenui" package is updated
      cancelable: true,
      title: translate(STRINGS.TAKE_A_PHOTO),
    })
    .then(
      (result) => {
        const cameraButton = 0;
        const galleryButton = 1;
        if (<any>result === cameraButton) {
          return CameraSource.Camera;
        } else if (<any>result === galleryButton) {
          return CameraSource.Photos;
        } else if (<any>result === -1) {
          // Dialog was canceled
          return null;
        } else {
          throw new Error("The Impossible Happened; " + JSON.stringify(result));
        }
      },
      () => {
        // Dialog was canceled
        return null;
      }
    );
}
